export default __webpack_public_path__ + "static/media/MADProject.1bf1c72d.webp";